import { Roles } from "../stores/authStore.ts";
import { useProductStore } from "../stores/productStore.ts";
import { isDriverParentAccessEnabled } from "../config/featureFlags.ts";
import {
  FOSOOL,
  FOSOOL_HOME,
  OSOOL,
  homeOfSide,
  modulesFor,
  osoolHomeFor,
  rememberedFor,
} from "./productSwitch.js";

/**
 * Where a signed-in person starts. `/admin/dashboard` (generalRoutes'
 * Dashboard) answers with this, and so does the login page, which goes
 * straight there: through `/admin/dashboard` it used to mount the whole Paper
 * Dashboard layout, and register the device, only to redirect.
 *
 * `auth` is the auth store's state (`useAuthStore.getState()`).
 */
export function homePathFor(user, auth) {
  if (auth.isSignedInUserBlocked()) return "/admin/unauthorized";

  switch (user.role) {
    case Roles.ROOT_ADMIN:
    case Roles.KINDERGARTEN_ADMIN:
    case Roles.KINDERGARTEN_USER: {
      // The home of the side this person was last on (Wosool's Home,
      // Fosool's or Osool's own) — only while that side is theirs, from the
      // same switches `useManagerRoutes` opens the modules with. Fosool's
      // pages are root's and the school admin's; office staff never get it.
      const modules = modulesFor({ role: user.role, settings: auth.kindergartenSettings });
      const homes = {
        [FOSOOL]:
          user.role !== Roles.KINDERGARTEN_USER && modules.education ? FOSOOL_HOME : null,
        [OSOOL]: osoolHomeFor(modules),
      };
      const { side } = rememberedFor(useProductStore.getState(), user.id);
      return homeOfSide({ side, homes });
    }
    case Roles.DRIVER:
      // A supervisor the school put in charge of its journeys lands on the
      // journeys themselves. `/manager/dashboard` is school-staff only and
      // would bounce them straight back — and the journeys are the only
      // reason they are on the web at all.
      if (auth.canManageJourneys()) return "/manager/trips";
      return isDriverParentAccessEnabled() ? "/admin/driver/dashboard" : "/admin/unauthorized";
    case Roles.PARENT:
      return isDriverParentAccessEnabled() ? "/admin/parent/dashboard" : "/admin/unauthorized";
    case Roles.ACCOUNTANT:
      // Finance is their job; the dashboard home is tracking and journey
      // widgets they may not use. Parents while the school has finance off.
      return auth.kindergartenSettings?.finance_enabled === true
        ? "/manager/finance"
        : "/manager/users/parents";
    default:
      return "/admin/unauthorized";
  }
}
